var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
import PropTypes from "prop-types";
import { css } from "styled-components";
import { boxShadowNone, boxShadowStandard, validBoxShadowValues } from "@nib-components/theme";
import { map } from "../../breakpoint";
var mapStringToSelector = function mapStringToSelector(string) {
  switch (string) {
    case "none":
      return boxShadowNone;
    case "standard":
      return boxShadowStandard || "hsla(0, 0%, 0%, .13) 0px 4px 8px 0px";
  }
};
export var boxShadow = function boxShadow(props) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref) {
    var boxShadow = _ref.boxShadow;
    return map(boxShadow, function (val) {
      return val !== undefined && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          box-shadow: ", ";\n        "])), mapStringToSelector(val));
    });
  });
};
export var boxShadowPropType = PropTypes.oneOf(validBoxShadowValues);
export var boxShadowPropTypeMap = PropTypes.oneOfType([boxShadowPropType, PropTypes.shape({
  xs: boxShadowPropType,
  sm: boxShadowPropType,
  md: boxShadowPropType,
  lg: boxShadowPropType,
  xl: boxShadowPropType,
  xxl: boxShadowPropType,
  xxxl: boxShadowPropType
})]);